export const WhatWeDoSvgs = [
  {
    icon: "ProductDesign",
    title: "Product Design",
    description: "We Design Digital Products That Are Intuitive, Engaging, And Built For Real-World Impact"
  },
  {
    icon: "UIDesign",
    title: "UI/UX Design",
    description: "We craft intuitive, visually engaging interfaces that prioritize user experience."
  },
  {
    icon: "WebDevelopment",
    title: "Web Development",
    description: "Robust, Scalable Websites Coded To Perfection For Performance And Reliability."
  },
  {
    icon: "BrandIdentity",
    title: "Brand Identity",
    description: "Building Brand Systems That Are Memorable, Strategic, And Visually Compelling."
  },
  {
    icon: "AiDriven",
    title: "AI-Driven Solutions",
    description: "We Integrate Intelligent Systems To Elevate User Experiences And Drive Smarter Digital Outcomes."
  },
  {
    icon: "IosAndroidApps",
    title: "IOS & Android Apps",
    description: "Developing Mobile Apps That Perform Beautifully Across All Devices."
  },
];